
//使用打印样式需写在行内或者使用react-inline-css插件
import React from 'react'
import {Divider, Steps, Row, Col, Input, Select, Checkbox, DatePicker,
    Button, Table, Popconfirm, TreeSelect, Tooltip, message,
    BackTop, Spin, Tabs, Modal} from 'antd'
import common from '@/public/common'
import { withRouter } from 'react-router-dom'
import {ajaxApi, postMethodDepartment, getMethod, submitMethod} from '@/server'
import { summation, getCookie, getParmUrl, outputMoney } from '../../public/utils'
import moment from 'moment'

class SummaryPrint extends React.Component{
    constructor(props) {
        super(props)
        this.state = {
          visible: false,
          info: {},
          data: []
        }
    }
    componentDidMount () {
      this.getDetails()
    }
    getDetails = () => {
        getMethod(common.SapUrl + '/reconciliation/query-detail/' + getParmUrl('code')).then((res) => {
            if (res) {
                this.setState({
                    info: res.data.item,
                    data: res.data.collect
                })
            }
        })
    }
    print = () => {
        console.log(window.document.getElementsByClassName('printSummary'))
        window.document.body.innerHTML = window.document.getElementsByClassName('printSummary')[0].innerHTML;
        window.print()
        window.location.reload()
    }
    render () {
        const { visible, info, data } = this.state
        return (
            <div className="summaryPrint">
                <Button shape="round" type="primary" onClick={this.print}>打印</Button>
                <Divider/>
                <div className="printSummary"  style={{ color:'#000',
                                                    position: 'relative',
                                                    width: '800px',
                                                    border: '1px solid #333',
                                                    marginLeft: '50%',
                                                    left: '-400px',
                                                    padding: '20px 20px',}}>
                    <div className="head" style={{ position: 'relative'}}>
                        <img className="logo" style={{
                             width: '120px',
                             height: '50px',
                             position: 'absolute',
                        }} src={require('./../../static/img/logo.png')}/>
                        <h1 style={{
                            fontSize: '20px',
                            fontWeight: 'bold',
                            textAlign: 'center',
                        }}>
                            <p style={{margin: '0', padding: '0'}}>{getParmUrl("poSubjectName")}来往对账单</p>
                            <p style={{margin: '0', padding: '0'}}>（对账期间：{ info.reconciliation_begin_time ? moment(info.reconciliation_begin_time).format('YYYY-MM-DD') + '~' + moment(info.reconciliation_end_time).format('YYYY-MM-DD') : ''}）</p>
                        </h1>
                    </div>
                    <div className="title" style={{marginBottom: '20px'}}>
                        <Row style={{marginBottom: '10px'}}>
                            <Col span={12}>
                                <label style={{textAlign: 'right', display: 'inline-block',width: '30%'}}>供应商名称：</label>
                                <span style={{color: '#3aa31f',textDecoration: 'underline'}}>{info.supplier_name}</span>
                            </Col>
                            <Col span={10}>
                                <label style={{ display: 'inline-block',width: '30%'}}>供应商代码：</label>
                                <span style={{color:'#277cc4'}}>{info.supplier_code}</span>
                            </Col>
                        </Row>
                        <Row style={{marginBottom: '10px'}}>
                            <Col span={12}>
                                <label style={{textAlign: 'right',display: 'inline-block',width: '30%'}}>对账单号：</label>
                                <span>{info.reconciliation_code}</span>
                            </Col>
                            <Col span={8}>
                                <label style={{ display: 'inline-block',width: '30%'}}>出账日：</label>
                                <span>{info.charge_off_time ? moment(info.charge_off_time).format('YYYY.MM.DD') : ''}</span>
                            </Col>
                        </Row>
                        <Row style={{marginBottom: '10px'}}>
                            <Col span={12}>
                                <label style={{textAlign: 'right',display: 'inline-block',width: '30%'}}>备注：</label>
                                <span>{info.remark}</span>
                            </Col>
                        </Row>
                    </div>
                    <table className="table" style={{width: '100%'}}>
                        <thead>
                            <tr>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>项目</td>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>期初</td>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>本期增加</td>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>本期减少</td>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>期末</td>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>预计冲账</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>采购应付</td>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>{data[0] ? outputMoney(data[0].begin_amount) : ''}</td>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>{data[0] ? outputMoney(data[0].add_amount) : ''}</td>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>{data[0] ? outputMoney(data[0].reduce_amount) : ''}</td>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>{data[0] ? outputMoney(data[0].end_amount) : ''}</td>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>{data[0] ? outputMoney(data[0].reconciliation_amount) : ''}</td>
                            </tr>
                            <tr>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>铺货应付</td>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>{data[0] ? data[1] ? outputMoney(data[1].begin_amount) : '' : ''}</td>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>{data[0] ? data[1] ? outputMoney(data[1].add_amount) : '' : ''}</td>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>{data[0] ? data[1] ? outputMoney(data[1].reduce_amount) : '' : ''}</td>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>{data[0] ? data[1] ? outputMoney(data[1].end_amount) : '' : ''}</td>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>{data[0] ? data[1] ? outputMoney(data[1].reconciliation_amount) : '' : ''}</td>
                            </tr>
                            <tr>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>货返应付</td>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>{data[0] ? data[2] ? outputMoney(data[2].begin_amount) : '' : ''}</td>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>{data[0] ? data[2] ? outputMoney(data[2].add_amount) : '' : ''}</td>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>{data[0] ? data[2] ? outputMoney(data[2].reduce_amount) : '' : ''}</td>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>{data[0] ? data[2] ? outputMoney(data[2].end_amount) : '' : ''}</td>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>{data[0] ? data[2] ? outputMoney(data[2].reconciliation_amount) : '' : ''}</td>
                            </tr>
                            <tr>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>返利（货返）</td>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>{data[0] ? data[3] ? outputMoney(data[3].begin_amount) : '' : ''}</td>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>{data[0] ? data[3] ? outputMoney(data[3].add_amount) : '' : ''}</td>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>{data[0] ? data[3] ? outputMoney(data[3].reduce_amount) : '' : ''}</td>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>{data[0] ? data[3] ? outputMoney(data[3].end_amount) : '' : ''}</td>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>{data[0] ? data[3] ? outputMoney(data[3].reconciliation_amount) : '' : ''}</td>
                            </tr>
                            <tr>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>返利（减账）</td>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>{data[0] ? data[4] ? outputMoney(data[4].begin_amount) : '' : ''}</td>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>{data[0] ? data[4] ? outputMoney(data[4].add_amount) : '' : ''}</td>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>{data[0] ? data[4] ? outputMoney(data[4].reduce_amount) : '' : ''}</td>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>{data[0] ? data[4] ? outputMoney(data[4].end_amount) : '' : ''}</td>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>{data[0] ? data[4] ? outputMoney(data[4].reconciliation_amount) : '' : ''}</td>
                            </tr>
                            <tr>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>返利（现金）</td>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>{data[0] ? data[5] ? outputMoney(data[5].begin_amount) : '' : ''}</td>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>{data[0] ? data[5] ? outputMoney(data[5].add_amount) : '' : ''}</td>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>{data[0] ? data[5] ? outputMoney(data[5].reduce_amount) : '' : ''}</td>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>{data[0] ? data[5] ? outputMoney(data[5].end_amount) : '' : ''}</td>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>{data[0] ? data[5] ? outputMoney(data[5].reconciliation_amount) : '' : ''}</td>
                            </tr>
                            <tr>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>预付款</td>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>{data[0] ? data[6] ? outputMoney(data[6].begin_amount) : '' : ''}</td>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>{data[0] ? data[6] ? outputMoney(data[6].add_amount) : '' : ''}</td>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>{data[0] ? data[6] ? outputMoney(data[6].reduce_amount) : '' : ''}</td>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>{data[0] ? data[6] ? outputMoney(data[6].end_amount) : '' : ''}</td>
                                <td style={{ border: '1px solid #333',width: '16.1%',textAlign: 'center',padding: '4px 0'}}>{data[0] ? data[6] ? outputMoney(data[6].reconciliation_amount) : '' : ''}</td>
                            </tr>
                        </tbody>
                    </table>
                    <div className="desc" style={{marginTop: '8px'}}>
                        <p>&nbsp;&nbsp;&nbsp;&nbsp;请贵公司核对以上账务，如与贵公司账簿一致，请在本函下端签字确认并加盖公司财务专用章或公章，
                            并在确认后5个工作日内将原件回至我公司。逾期视为对本函内容的认可。对您的支持，
                            我们表示由衷的感谢！如对以上内容有任何疑问，请联系：</p>
                        <p><span>联系人：</span>刘芬</p>
                        <p><span>电话：</span>15951857145</p>
                        <p><span>地址：</span>南京市白下区光华路104号江苏经贸职业技术学院内8号楼</p>
                    </div>
                    <div className="sign" style={{  marginTop: '16px',textAlign: 'right'}}>
                        <p style={{ marginLeft: '60%',width: '30%',textAlign: 'left'}}>对账人签字：</p>
                        <p style={{ marginLeft: '60%',width: '30%',textAlign: 'left'}}>签章（财务专用章或公章）：</p>
                        <p style={{ marginLeft: '60%',width: '30%',textAlign: 'left'}}>日期：</p>
                    </div>
                </div>
            </div>
        )
    }

}
export default SummaryPrint



// WEBPACK FOOTER //
// ./src/pages/supplierRecantion/summaryPrint.js